module.exports = __webpack_public_path__ + "img/calendar.c850e194.svg";